import { render, staticRenderFns } from "./PowerOfAttorneyOneSignatory.vue?vue&type=template&id=36079edc&scoped=true&"
import script from "./PowerOfAttorneyOneSignatory.vue?vue&type=script&lang=js&"
export * from "./PowerOfAttorneyOneSignatory.vue?vue&type=script&lang=js&"
import style0 from "./PowerOfAttorneyOneSignatory.vue?vue&type=style&index=0&id=36079edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36079edc",
  null
  
)

export default component.exports